const DateFormats = {
    DATE_FORMAT_API: 'YYYY-MM-DD',
    DATE_FORMAT_SHORT: 'DD/MM/YYYY',
    DATE_FORMAT_MEDIUM: 'D MMM YYYY',
    DATE_FORMAT_LONG: 'D MMMM YYYY',
    DATE_FORMAT_FULL: 'dddd D MMMM YYYY',

    DATETIME_FORMAT_API: 'YYYY-MM-DD HH:mm:ss',
    DATETIME_FORMAT_SHORT: 'DD/MM/YYYY HH:mm',
    DATETIME_FORMAT_MEDIUM: 'D MMM YYYY HH:mm',
    DATETIME_FORMAT_LONG: 'D MMMM YYYY HH:mm',
    DATETIME_FORMAT_FULL: 'dddd D MMMM YYYY HH:mm'
}

export default DateFormats
